import styled, {css, keyframes} from 'styled-components';


export const fadeIn = keyframes `
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
`;


export const GstinLoader = styled.div(
    props => css`
    display: inline-block;
    position: relative;
    top:-1rem;
    div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        top:0rem;
        width:2.5rem;
        height: 2.5rem;
        margin: 0.8rem;
        border: 3px solid ${props.theme.colors.blue.base};
        border-radius: 50%;
        animation: ${fadeIn} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: ${props.theme.colors.blue.base} transparent transparent transparent;
    
        :nth-child(1) {
            animation-delay: -0.45s;
        }
        :nth-child(2) {
            animation-delay: -0.3s;
        }
    }
`);

export const ButtonLoader = styled.div(
    props => css`
    display: inline-block;
    position: relative;
    width: 4rem;
    height: 4rem;
    div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        top:0rem;
        width:2.5rem;
        height: 2.5rem;
        margin: 0.8rem;
        border: 3px solid ${props.theme.colors.white.base};
        border-radius: 50%;
        animation: ${fadeIn} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: ${props.theme.colors.white.base} transparent transparent transparent;
    
        :nth-child(1) {
            animation-delay: -0.45s;
        }
        :nth-child(2) {
            animation-delay: -0.3s;
        }
    }
`);